<template>
    <div class="error-center" v-bind:class="{ 'ms-error-center': isIe }">
        <div class="error-block">
            <div class="error-img"></div>
            <div>{{ pageText }}</div>
            <div>{{ pageSubText }}</div>
        </div>
        <div v-if="showLogoutButton" class="py-3">
            <b-link href="#" @click="$_onLogout">{{
                $t('logOutUnknownUser')
            }}</b-link>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                pageText: '',
                pageSubText: '',
                isIe: false,
                showLogoutButton: false
            };
        },

        props: {
            message: { type: String, required: false, default: '' },
            error: { type: String, required: false, default: '' }
        },

        mounted() {
            this.$_initializedErrorText();
        },

        computed: {
            userName() {
                if (this.$store.getters.userInfo?.userName) {
                    return this.$store.getters.userInfo.userName;
                }
                if (this.$store.getters.getUserInfo?.userName) {
                    return this.$store.getters.getUserInfo.userName;
                }
                return this.unknownUserName;
            },

            ...mapState(['unknownUserName'])
        },

        methods: {
            $_onLogout() {
                this.$router.push('/logout');
            },

            // eslint-disable-next-line complexity
            $_initializedErrorText() {
                if (
                    this.message === 'dashboard_noaccess' ||
                    this.message === 'unknown_user'
                ) {
                    this.pageText = this.$t(`errorPage.${this.message}`, [
                        `${this.userName}`
                    ]);
                } else {
                    this.pageText = this.$t(`errorPage.${this.message}`);
                }

                switch (this.message) {
                    // Generic
                    case 'access_denied':
                        this.pageSubText = this.$t(
                            `errorPage.pageSubText.${this.message}`
                        );
                        this.showLogoutButton = false;
                        break;
                    // Web
                    case 'dashboard_noaccess':
                    case 'webtheme_unknown':
                    case 'webtheme_no_parameters':
                    case 'webtheme_invalid_parameters':
                    case 'mobile_no_license':
                        this.pageSubText = this.$t(
                            'errorPage.pageSubText.contactApplicationManager'
                        );
                        break;
                    // Portal
                    case 'portal_no_parameter':
                    case 'portal_incorrect_organization':
                    case 'portal_error_licenses':
                    case 'portal_error_webthemes':
                    case 'portal_no_license':
                    case 'portal_no_webthemes':
                        this.pageSubText = this.$t(
                            'errorPage.pageSubText.contactCadac'
                        );
                        break;
                    case 'unknown_user':
                        this.pageSubText = '';
                        this.showLogoutButton = true;
                        break;
                    // Access denied IE
                    case 'access_denied_ie':
                        this.isIe = true;
                        this.pageSubText = this.$t('accessDeniedIEPageText');
                        break;
                }
            }
        }
    };
</script>

<style scoped>
.error-img {
    background-image: url(/img/NED__NedGlobe.png);
    background-size: contain;
    background-repeat: no-repeat;
    height: 70px;
    margin-bottom: 15px;
}

.error-center {
    min-height: 100vh;
    display: flex;
    display: -ms-flexbox;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.error-block {
    padding: 40px;
    -webkit-box-shadow: 0 0 3px #000;
    box-shadow: 0 0 3px #000;
}

.ms-error-center {
    margin-top: 150px;
}
</style>
